export default __webpack_public_path__ + "static/media/ic-pause.e513f820.svg";